import slide1 from '../../assets/pexels-cottonbro-3993447.jpg';
// import slide2 from '../../assets/drink-drippy-HuQaeOjOLeE-unsplash.jpg';
import slide3 from '../../assets/pexels-n-voitkevich-5128235.jpg';
import slide5 from '../../assets/pexels-cottonbro-5871928.jpg';
import slide6 from '../../assets/pexels-shvetsa-5069493.jpg';
import slide7 from '../../assets/pexels-brollwalamunda-16972143.jpg';
import img1 from '../../assets/istockphoto-1289242385-1024x1024.jpg';
import img2 from '../../assets/pexels-thgusstavo-2061820.jpg';
import img3 from '../../assets/pexels-jibarofoto-17553848.jpg';

export const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
};

export const galleryImages = [
    { src: slide1, watermark: "Hair Styling" },
    { src: img2, watermark: "Hair Cut " },
    { src: slide3, watermark: "Facials & Skincare" },
    { src: img1, watermark: "Makeup" },
    { src: img3, watermark: "Party Looks" },
    { src: slide5, watermark: "Manicure & Pedicure" },
    { src: slide6, watermark: "Skincare Treatments" },
    { src: slide7, watermark: "Bridal Makeup" },
  ];
  

export const services = [
  {
    title: 'Hair Styling',
    description: 'Expert haircuts, coloring, and styling for all hair types.',
    image: slide1,
  },
  {
    title: 'Facials & Skincare',
    description: 'Relaxing facials, deep cleansing, and personalized skincare treatments.',
    image: slide6,
  },
  {
    title: 'Manicure & Pedicure',
    description: 'Professional manicure and pedicure services for beautiful nails.',
    image: slide5,
  },
  {
    title: 'Makeup',
    description: 'Bridal, party, and everyday makeup application by our skilled artists.',
    image: slide7,
  },
];

export const remarks = [
  {
    name: 'Jane Doe',
    comment: 'Amazing service! I loved my new hairstyle.',
    rating: 5,
  },
  {
    name: 'Alice Smith',
    comment: 'The facial was so relaxing. Highly recommend!',
    rating: 4,
  },
  {
    name: 'Bob Johnson',
    comment: 'Great manicure and friendly staff.',
    rating: 5,
  },
];